import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import { ApiService } from '../../../../core/services/api/api.service';
import { PlatformService } from '../../../../core/services/platform/platform.service';
import { UtilService } from '../../../../core/services/util/util.service';
import { environment } from '../../../../../environments/environment';

interface OrderItem {
  product_name: string;
  model_name: string;
  seller_sku: string;
  qty: number | string;
}

interface OrderRow {
  order_platform: string;
  create_at: string;
  items: OrderItem[];
}

@Component({
  selector: 'app-branch-order',
  templateUrl: './branch-order.component.html',
  styleUrl: './branch-order.component.css'
})
export class BranchOrderComponent implements OnInit {
  faBoxOpen = faBoxOpen;

  channels: any[] = [];
  channelSelected: string = '';
  branchKeyword: string = '';
  branchesFilter: any[] = [];
  showBranchFilter: boolean = false;

  loading: boolean = false;
  orders: OrderRow[] = [];
  errorMessage: string = '';

  private readonly itemsKeys = ['items', 'item_list', 'order_items', 'products', 'lines', 'order_item_list'];

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private platformService: PlatformService,
    private utilService: UtilService,
  ) {
    this.channels = (platformService?.channels || []).filter(c => !!c.is_branch);
    this.branchesFilter = this.channels;
  }

  ngOnInit(): void {
    const channelQp = this.route.snapshot.queryParamMap.get('channel');
    const pick = this.channels.find(c => c.shop_ref === channelQp) || this.channels[0];
    if (pick) {
      this.channelSelected = pick.shop_ref;
      this.branchKeyword = pick.platform_name;
      this.fetchOrders();
    }
  }

  async fetchOrders() {
    this.loading = true;
    this.errorMessage = '';
    this.orders = [];
    const branch = this.channels.find(c => c.shop_ref === this.channelSelected);
    const member_id = branch?.member_id;
    if (!member_id) {
      this.errorMessage = 'ไม่พบ member_id ของสาขา';
      this.loading = false;
      return;
    }
    try {
      const url = `${environment.ORDER_MANAGEMENT_END_POINT}/pos-shopee-order/unpack`;
      const res: any = await this.apiService.getCall(url, { member_id });
      const rows = Array.isArray(res) ? res : (res?.data || []);
      this.orders = rows.map((r: any) => this.normalizeOrder(r));
    } catch (e: any) {
      this.errorMessage = e?.message || 'เกิดข้อผิดพลาดในการเรียก API';
      this.orders = [];
    } finally {
      this.loading = false;
    }
  }

  private normalizeOrder(raw: any): OrderRow {
    const order_platform = raw?.order_platform != null ? String(raw.order_platform) : '-';
    const create_at = this.formatDate(raw?.create_at ?? raw?.created_at ?? raw?.create_date ?? raw?.created_date);
    const rawItems = this.firstArray(raw, this.itemsKeys);
    const items: OrderItem[] = rawItems.map((it: any) => ({
      product_name: it?.product_name ?? it?.item_name ?? '',
      model_name: it?.model_name ?? '',
      seller_sku: it?.seller_sku ?? it?.item_sku ?? it?.sku ?? '',
      qty: it?.qty ?? it?.quantity ?? it?.model_quantity_purchased ?? 0,
    }));
    return { order_platform, create_at, items };
  }

  private formatDate(value: any): string {
    if (value === null || value === undefined || value === '') return '';
    const d = typeof value === 'number'
      ? this.utilService.dayjs.unix(value > 1e12 ? Math.floor(value / 1000) : value)
      : this.utilService.dayjs(value);
    return d.isValid() ? d.format('DD/MM/YYYY HH:mm') : String(value);
  }

  private firstArray(obj: any, keys: string[]): any[] {
    for (const k of keys) {
      if (Array.isArray(obj?.[k])) return obj[k];
    }
    return [];
  }

  filterBranches() {
    const k = (this.branchKeyword || '').toLowerCase();
    this.branchesFilter = this.channels.filter(c =>
      (c.platform_name || '').toLowerCase().includes(k)
    );
    this.showBranchFilter = true;
  }

  selectBranch(branch: any) {
    const changed = branch.shop_ref !== this.channelSelected;
    this.channelSelected = branch.shop_ref;
    this.branchKeyword = branch.platform_name;
    this.branchesFilter = this.channels;
    this.showBranchFilter = false;
    if (changed) this.fetchOrders();
  }

  openBranchFilter() {
    this.branchesFilter = this.channels;
    this.showBranchFilter = true;
  }

  closeBranchFilter() {
    setTimeout(() => {
      this.showBranchFilter = false;
      const current = this.channels.find(c => c.shop_ref === this.channelSelected);
      if (current) this.branchKeyword = current.platform_name;
    }, 150);
  }
}
